import type { QueryKey, UseQueryResult } from '@tanstack/react-query'
import type { GetActiveElevatorsQueryResponse } from '@/api/kubik/credit'
import { useGetActiveElevators } from '@/api/kubik/credit'
import type { TAdvancePaymentCalculatorElevator } from '../types'

type TProps = {
  enabled: boolean
}

type TResponse = UseQueryResult<TAdvancePaymentCalculatorElevator[], unknown> & {
  queryKey: QueryKey
}

type TResponseAdapter = (data: GetActiveElevatorsQueryResponse) => GetActiveElevatorsQueryResponse

export const useAdvancePaymentCalculatorElevators = ({ enabled }: TProps): TResponse => {
  const response = useGetActiveElevators({
    query: {
      enabled,
      select: ((data: GetActiveElevatorsQueryResponse): TAdvancePaymentCalculatorElevator[] =>
        data.map<TAdvancePaymentCalculatorElevator>(({ id, name, address, location, regionCode, availableForCalculate }) => ({
          id,
          name,
          address,
          regionCode,
          location: { latitude: location.lat ?? 0, longitude: location.lon ?? 0 },
          isAvailableForCalculation: availableForCalculate,
          // некорректно выводится тип адаптера в kubik: преобразование к сгенерированному типу
        }))) as unknown as TResponseAdapter,
    },
  })

  // некорректно выводится тип адаптера в kubik: преобразование из сгенерированного типа во внутренний
  return response as TResponse
}
